// let wxAppId = "wxd3ce57474377102a"; //测试环境
//let wxAppId = "wxc06334e77d6bbc77"; //正式环境
// let wxAppSecret = "6c7792c972edfbfd1c49f8db920b304e"; //测试环境
//let wxAppSecret = "48f8bd13759dbefc4b1a8bb0d0ebe7ea"; //正式环境

// let linkedUrl = 'http://mydyac.sipyun.com/?voteId=1_1'; //当前页面Url（测试环境）
//let linkedUrl = 'http://acui.danyang.com/?voteId=1_1'; //当前页面Url（正式环境）
let linkedUrl = 'http://acui.danyang.com/dycbaCommentList'; //当前页面Url（正式环境）

function GetQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}


export default {linkedUrl, GetQueryString };
